import styled from "styled-components";
import { motion } from "framer-motion";
import { letterAnimation, textAnimate } from "../animation";
import Skill from "./Skill";
import html from "../assets/svgs/html.svg";
import javascript from "../assets/svgs/javascript.svg";
import git from "../assets/svgs/git.svg";
import react from "../assets/svgs/react.svg";
import redux from "../assets/svgs/redux.svg";
import sass from "../assets/svgs/sass.svg";
import tailwind from "../assets/svgs/tailwind.svg";
import nextjs from "../assets/svgs/nextjs.svg";
import go from "../assets/svgs/go.svg";
import firebase from "../assets/pngs/firebase.png";
import postgresql from "../assets/pngs/postgresql.png";
import mongodb from "../assets/svgs/mongodb.svg";
import css from "../assets/pngs/css.png";
import styledC from "../assets/pngs/styled.png";

const Skills = () => {
  return (
    <Section>
      <Container id="skills">
        <motion.div
          initial="hide"
          whileInView={"show"}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ staggerChildren: 0.1 }}
          className="title"
        >
          <motion.span variants={letterAnimation}>S</motion.span>
          <motion.span variants={letterAnimation}>K</motion.span>
          <motion.span variants={letterAnimation}>I</motion.span>
          <motion.span variants={letterAnimation}>L</motion.span>
          <motion.span variants={letterAnimation}>L</motion.span>
          <motion.span variants={letterAnimation}>S</motion.span>
        </motion.div>
        <p className="description">
          I make use of languages and technologies such as:
        </p>
        <motion.div
          initial="hide"
          whileInView={"show"}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ staggerChildren: 0.1 }}
          className="skills"
        >
          <motion.div variants={textAnimate}>
            <Skill image={go} desc="Go" name="Go" />
            <Skill image={postgresql} desc="PostgreSQL" name="PostgreSQL" />
            <Skill image={mongodb} desc="MongoDB" name="MongoDB" />
            <Skill image={html} desc="html" name="HTML" />
            <Skill image={css} desc="CSS" name="CSS" />
            <Skill image={javascript} desc="JavaScript" name="JavaScript" />
            <Skill image={sass} desc="SASS" name="SASS" />
            <Skill image={react} desc="React" name="React" />
            <Skill image={nextjs} desc="Next" name="Next" />
            <Skill
              image={styledC}
              desc="Styled-components"
              name="Styled-components"
            />
            <Skill image={tailwind} desc="Tailwind" name="Tailwind" />
            <Skill image={firebase} desc="Firebase" name="Firebase" />
            <Skill image={redux} desc="Redux" name="Redux" />
            <Skill image={git} desc="Git" name="Git" />
          </motion.div>
        </motion.div>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  margin-top: 3rem;
  width: 100%;
  min-height: 50vh;
`;

const Container = styled.div`
  width: 85%;
  margin: 0 auto;
  .title {
    text-align: left;
    overflow: hidden;
    span {
      display: inline-block;
      font-family: "Antonio", sans-serif;
      font-weight: 700;
      font-size: 8rem;
      color: rgba(149, 149, 149, 0.2);
    }
  }

  .description {
    margin-top: 2rem;
    font-size: 1.2rem;
  }

  .skills {
    margin-top: 1.5rem;
    div {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 1rem;
    }
  }

  @media screen and (max-width: 600px) {
    .title {
      width: 100%;
      span {
        font-size: 4.5rem;
      }
    }

    .description {
      font-size: 1rem;
    }

    .about {
      p {
        font-size: 1rem;
        line-height: 2rem;
      }
    }
  }
`;

export default Skills;
